import Api from './api';
import NewsItem from 'models/news-item';
import { JsonApiResponse, toJsonApiResponse } from 'utils/json-api';

export default class NewsService {
    static async fetchNews(): Promise<JsonApiResponse<NewsItem[]>> {
        let response = await Api.get('newsItems', true);
        return await toJsonApiResponse<NewsItem[]>(response);
    }
}